import { Form } from 'antd';
import React, { useEffect, useState } from 'react';
import { CSVLink } from 'react-csv';
import { getAlumni } from '../../services/learnerService';
import { formatAlumniCSVData } from '../../utilities/formatData';
import AlumniSearch from './components/AlumniSearch';
import AlumniTable from './components/AlumniTable';
const Alumni = () => {
  const [alumni, setAlumni] = useState([]);
  const [totalCount, setTotalCount] = useState(0);
  const [pageNo, setPageNo] = useState(1);
  const [pageSize, setPageSize] = useState(20);
  const [offset, setOffset] = useState((pageNo - 1) * pageSize);
  const [uniqueAlumCount, setUniqueAlumCount] = useState(0);
  const [fetching, setFetching] = useState(false);
  const [searchFilter, setSearchFilters] = useState({});
  const [csvReport, setCsvReport] = useState({});

  useEffect(() => {
    fetchAlumni();
  }, [pageNo, pageSize, searchFilter]);

  useEffect(() => {
    fetchCSVData();
  }, [searchFilter]);

  const [form] = Form.useForm();

  const onReset = () => {
    form.resetFields();
    setSearchFilters({});
    setOffset(0);
    setPageNo(1);
    fetchCSVData();
  };
  const onFinish = (values) => {
    setPageNo(1);
    setSearchFilters(values);
  };

  const fetchCSVData = () => {
    const formatted = { ...searchFilter };

    if (formatted.startDate)
      formatted.startDate = formatted.startDate.format('YYYY-MM-DD');
    getAlumni({}, formatted)
      .then((response) => {
        const data = response.data.data;
        setCsvReport(formatAlumniCSVData(data.paginatedList));
      })
      .catch((error) => {
        console.log('Error getting data from the admin backend:', error);
        alert('Getting data from the backend failed!');
      });
  };

  const fetchAlumni = () => {
    const formatted = { ...searchFilter };

    if (formatted.startDate)
      formatted.startDate = formatted.startDate.format('YYYY-MM-DD');
    setFetching(false);
    const paginationParams = { paginate: 1, pageNo, pageSize };
    getAlumni(paginationParams, formatted)
      .then((response) => {
        const data = response.data.data;
        setUniqueAlumCount(data?.uniqueCount);
        setFetching(false);
        setTotalCount(data?.totalCount);
        setAlumni(data.paginatedList);
      })
      .catch((error) => {
        setFetching(false);
        console.log('Error getting data from the admin backend:', error);
        alert('Getting data from the backend failed!');
      });
  };

  const onPaginationChange = (data) => {
    setPageNo(data.current);
    setPageSize(data.pageSize);
    setOffset(data.current * data.pageSize - data.pageSize);
  };

  return (
    <div>
      <div>
        <section>
          <AlumniSearch
            onFinish={onFinish}
            onReset={onReset}></AlumniSearch>
        </section>
      </div>
      <div>
        <section>
          <h1>Total Records: {totalCount}</h1>
          <h1>Unique Alumni: {uniqueAlumCount}</h1>
          {csvReport.data && csvReport.data.length > 0 ? (
            <CSVLink
              data={csvReport.data}
              headers={csvReport.headers}
              filename={csvReport.filename}>
              Export to CSV
            </CSVLink>
          ) : null}
        </section>
        <br /> <br /> <br />
        <section>
          <AlumniTable
            data={alumni}
            onPaginationChange={onPaginationChange}
            current={pageNo}
            totalCount={totalCount}
            fetching={fetching}
            offset={offset}
          />
        </section>
      </div>
    </div>
  );
};

export default Alumni;
